(function () {
  function initStagger(root) {
    if (root.dataset.staggerInit === 'true') return;
    root.dataset.staggerInit = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.b3-stagger__card'));
    var total = cards.length;
    if (!total) return;

    var centerIndex = 0;

    function getCardSize() {
      var isDesktop = window.matchMedia('(min-width: 640px)').matches;
      var val = isDesktop ? root.dataset.sizeDesktop : root.dataset.sizeMobile;
      return parseInt(val, 10) || (isDesktop ? 365 : 290);
    }

    function render() {
      var cardSize = getCardSize();
      root.style.setProperty('--b3-stagger-card-current-size', cardSize + 'px');
      var half = total / 2;

      cards.forEach(function (card, i) {
        var pos = i - centerIndex;
        if (pos > half) pos -= total;
        if (pos < -half) pos += total;

        card.dataset.pos = pos;

        var isCenter = pos === 0;
        card.classList.toggle('is-active', isCenter);

        var translateY = isCenter ? -65 : (pos % 2 ? 15 : -15);
        var rotate = isCenter ? 0 : (pos % 2 ? 2.5 : -2.5);
        var translateX = (cardSize / 1.5) * pos;

        card.style.zIndex = isCenter ? 10 : 0;
        card.style.transform =
          'translate(-50%, -50%) translateX(' + translateX + 'px) translateY(' + translateY + 'px) rotate(' + rotate + 'deg)';
      });
    }

    function move(steps) {
      centerIndex = ((centerIndex + steps) % total + total) % total;
      render();
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var pos = parseInt(card.dataset.pos, 10) || 0;
        if (pos !== 0) move(pos);
      });
    });

    root.querySelectorAll('.b3-stagger__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        move(parseInt(btn.dataset.direction, 10));
      });
    });

    window.addEventListener('resize', render);

    document.addEventListener('shopify:block:select', function (e) {
      var idx = cards.indexOf(e.target);
      if (idx > -1) {
        centerIndex = idx;
        render();
      }
    });

    render();
  }

  function init() {
    document.querySelectorAll('.b3-stagger').forEach(initStagger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.b3-stagger') : null;
    if (root) {
      root.dataset.staggerInit = '';
      initStagger(root);
    }
  });
})();
